module.exports = __webpack_public_path__ + "static/software-9c3e968aa14c528a6201b5490ae207bd.svg";